import React, { useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { MdOutlineCancel, MdDone } from "react-icons/md";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import img from "../../assets/contact.png";

const Contact = () => {
  const [done, setDone] = useState(false);
  const [status, setStatus] = useState(false);

  const form = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const sendEmail = (e) => {
    emailjs
      .sendForm(
        "service_9nrsx0x",
        "template_5runyse",
        form.current,
        "user_jUX53QAMNM10iHuCRhjro"
      )
      .then(
        (result) => {
          console.log(result.text);

          setDone(true);
          setStatus(false);
        },
        (error) => {
          console.log(error.text);
          setDone(false);
          setStatus(true);
        }
      );
  };
  useEffect(() => {
    if (status === true) {
      setTimeout(() => {
        setStatus(false);
      }, 3000);
    }
  }, [status]);

  useEffect(() => {
    if (done === true) {
      setTimeout(() => {
        setDone(false);
      }, 3000);
    }
  }, [done]);

  return (
    <section id="contact">
      <h2>Contact me</h2>
      <div className="contact-container">
        <div className="contact-img">
          <img src={img} alt="contact-img" />
        </div>
        <div className="contact-form">
          <form ref={form} onSubmit={handleSubmit(sendEmail)}>
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                {...register("name", { required: true })}
              />
              {errors.name && (
                <p className="error">please your name is required.</p>
              )}
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                {...register("email", { required: true })}
              />
              {errors.name && (
                <p className="error">please your Email address is required.</p>
              )}
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                {...register("message", { required: true })}
              />
              {errors.name && <p className="error">Message is empty.</p>}
            </div>
            <input type="submit" value="Send" className="send" />
            {done ? (
              <p className="status-done">
                <MdDone style={{ marginRight: "1rem" }} /> Message sent
              </p>
            ) : null}
            {status ? (
              <p className="status-error">
                <MdOutlineCancel size={25} style={{ marginRight: "1rem" }} />
                Error please check your network
              </p>
            ) : null}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
